<template>
  <div class="map-view">
    <provider-map class="provider-map" />
    <map-legend :categories="rootCategories" />
  </div>
</template>

<style scoped>
  .map-view {
    margin-top: 24px;
  }
</style>

<script>
import ProviderMap from '@/components/map/ProviderMap.vue';
import MapLegend from '@/components/map/MapLegend.vue';

export default {
  name: 'Map',
  computed: {
    rootCategories() {
      return this.$store.getters.getRootCategories;
    },
  },
  components: {
    ProviderMap,
    MapLegend,
  },
};
</script>
